// @access  Private
import axios from "axios";
import firebase from '../fire';
import { createBrowserHistory } from 'history';
// import {Router} from 'react-router-dom';
import {
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  AUTH_LOADING,
  FIREBASE_USER_LOADED,
  FIREBASE_SUCCESS_USER
} from "./types";
// import setAuthToken from "../utils/setAuthToken";
export const loadUser = () => async (dispatch) => {
  dispatch({
    type: AUTH_LOADING,
  });

  // if (localStorage.token) {
  //   setAuthToken(localStorage.token);
  // }

  try {
    let user = firebase.auth().currentUser;
    if (user) {
      dispatch({
        type: FIREBASE_USER_LOADED,
        payload: user,
      });
    } else{
      dispatch({
        type: AUTH_ERROR,
      });
    }
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

export const login = (email, password) => async (dispatch) => {
  dispatch({
    type: AUTH_LOADING,
  });
  


  var userLogged = false;
  await firebase.auth().signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        console.log('user', firebase.auth().currentUser._lat)
        
        // dispatch({
        //   type: FIREBASE_SUCCESS_USER,
        //   payload: { email: firebase.auth().currentUser.email, token: firebase.auth().currentUser.refreshToken},
        // });
        // dispatch(loadUser());
        userLogged = true;
        localStorage.setItem('email', firebase.auth().currentUser.email)
        localStorage.setItem('token', firebase.auth().currentUser._lat)
      })
      .catch((err) => {

        dispatch({
          type: LOGIN_FAIL,
          payload: err,
        });
        if (err.response) {
          const errors = err.response.data.errors;
          if (errors) {
            // errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
          }
        }
        // dispatch({
        //   type: LOGIN_FAIL,
        //   payload: err.response.data,
        // });
      });

      if(userLogged){
        dispatch({
          type: FIREBASE_SUCCESS_USER,
          payload: { user: {email: firebase.auth().currentUser.email}, token: firebase.auth().currentUser.refreshToken}
        });
      }

        // window.location.href = '/dashboard'

        // dispatch(loadUser());
};


export const currentUser = () => async (dispatch) => {
  
  let myPromise = new Promise(async (myResolve, myReject) => {
    let user = firebase.auth().currentUser;
    if(user){
      myResolve(user);
    } else {
      myReject('error')
    }
  });

  // let myPromise = new Promise(async (myResolve, myReject) => {
  //   if (localStorage.token) {
  //     setAuthToken(localStorage.token);
  //   }
  //   try {
  //     const res = await axios.get(Base_url + "/users/auth");
  //     if (res.data.status == "Success") {
  //       myResolve(res.data.data);
  //     }
  //   } catch (err) {
  //     myReject("error");
  //   }
  // });
  return myPromise;
};

export const logout = () => (dispatch) => {
  firebase.auth().signOut();
  dispatch({ type: LOGOUT });
};
